import { gql } from '@apollo/client';

export const localTypeDefs = gql`
    type Select {
        key: String!
        label: String!
        value: String!
    }

    extend type UserType {
        fullName: String
        isGuest: Boolean!
        isLoggedIn: Boolean!
        isPersonalInfoCompleted: Boolean!
        languageSelect: Select!
        phoneCountryPrefix: String
        phoneNonPrefixed: String
    }
`;
